import { Group, Icon, Text } from '@inflearn/ds-react';
import { faCheck, faXmark } from '@inflearn/pro-solid-svg-icons';

type ValidationItemProps = {
  isValid: boolean;
  text: string;
};

/**
 * 개별 validation 규칙의 상태를 표시하는 컴포넌트
 * 체크마크(성공) 또는 X마크(실패)와 함께 메시지를 표시합니다.
 */
export const ValidationItem = ({ isValid, text }: ValidationItemProps) => (
  <Group spacing={8} noWrap align="center">
    <Icon
      width={12.5}
      size="2xs"
      icon={isValid ? faCheck : faXmark}
      color={isValid ? 'infgreen.7' : 'red.7'}
    />

    <Text color={isValid ? 'infgreen.7' : 'red.7'} weight={400} size="xs" component="span">
      {text}
    </Text>
  </Group>
);
